import { TRC_ROUTES } from '@/TRC/constants/trcRoutes';
import { getSignupRoute } from '@/constants/featureFlags';
import { LESSON_PLAN_LABELS } from '@/constants/lessonPlanLabels';

export const adminSidebarNavigationItems = [
	{ path: '/AdminDashboard/AllVideos', text: 'All Videos' },
	{ path: '/AdminDashboard/Check', text: 'Add Videos(vimeo)' },
	{ path: '/AdminDashboard/AddVideos', text: 'Add Videos(mux)' },
	{ path: '/AdminDashboard/Reaction', text: 'Video Reactions' },
	// { path: '/AdminDashboard/Analytics', text: 'Analytics' },
	// { path: '/AdminDashboard/UserEngagement', text: 'User Engagement' },
	{
		text: 'Chargebee',
		subItems: [
			{ path: '/AdminDashboard/chargebee-portal', text: 'Chargebee Operational Portal' },
			{ path: '/AdminDashboard/cancellations', text: 'Cancellations' }
		]
	},
	{ path: '/AdminDashboard/TagManagement', text: 'Tag Management' },
	{ path: '/AdminDashBoard/Instructors', text: 'Instructors' },
	{ path: '/AdminDashboard/AllUsers', text: 'All Users' },
	{ path: '/AdminDashboard/featured-playlist', text: 'Featured Playlists' },
	{ path: '/AdminDashboard/moderation', text: 'Moderation' },
	{ path: '/AdminDashboard/notification', text: 'Notification' },
	{ path: '/AdminDashboard/banners', text: 'Banner' },
	{ path: '/AdminDashboard/popup', text: 'Popup' },
	{ path: '/AdminDashboard/TRC-approval', text: 'Approve New TRC Request' },
	{ path: '/AdminDashboard/TRC-content', text: 'TRC Content' },
	{ path: '/AdminDashboard/lesson-plans', text: LESSON_PLAN_LABELS.PROGRESSIVE },
	{ path: '/AdminDashboard/subtitle-generator', text: 'Subtitle Generator' },
	{ path: '/AdminDashboard/sync-studio-views', text: 'Sync Studio Views' },
	{ path: '/AdminDashboard/links', text: 'Link in Bio' }
];

export const buildRoutes = {
	toMainHome: () => `/`,
	toLogin: () => `/Login`,
	toSignUp: () => getSignupRoute(),
	toForgotPassword: () => `/forgot`,
	toAllVideos: () => `/AllVideos`,
	toAdminAllVideos: () => `/AdminDashboard/AllVideos`,
	toPlans: () => `/Plans`,
	toPlayerPage: id => `/PlayerPage?v=${id}`,
	toReactionStats: () => `/AdminDashboard/Reaction/reaction-stats`,
	toTRCEditContent: id => `/AdminDashboard/TRC-edit/${id}`,
	toTRCAddContent: () => `/AdminDashboard/TRC-add`,
	toTRCContent: () => `/AdminDashboard/TRC-content`,
	toTRCHome: (basePath = TRC_ROUTES.TRC_HOME) => basePath,
	toTRCLessonPlans: (basePath = TRC_ROUTES.TRC_HOME) => `${basePath}/${TRC_ROUTES.LESSON_PLANS}`,
	toTRCProgressiveLessonPlans: (basePath = TRC_ROUTES.TRC_HOME) => `${basePath}/${TRC_ROUTES.PROGRESSIVE_LESSON_PLANS}`,
	// toStudioHubLessonPlans: (basePath = TRC_ROUTES.STUDIO_HUB_HOME) => `${basePath}/${TRC_ROUTES.LESSON_PLANS}`,
	toTRCResources: (basePath = TRC_ROUTES.TRC_HOME) => `${basePath}/${TRC_ROUTES.RESOURCES}`,
	toTRCVideos: (basePath = TRC_ROUTES.TRC_HOME) => `${basePath}/${TRC_ROUTES.VIDEOS}`,
	toTRCViewAll: (basePath = TRC_ROUTES.TRC_HOME) => `${basePath}/${TRC_ROUTES.VIEW_ALL}`,
	toTRCSearch: (query, basePath = TRC_ROUTES.TRC_HOME) => `${basePath}/${TRC_ROUTES.SEARCH}?search_query=${query}`,
	toTRCAccess: (basePath = TRC_ROUTES.TRC_HOME) => `${basePath}/${TRC_ROUTES.ACCESS}`,
	toTRCResubmit: (basePath = TRC_ROUTES.TRC_HOME) => `${basePath}/${TRC_ROUTES.RESUBMIT}`,
	toTRCDynamicRoute: (route, basePath = TRC_ROUTES.TRC_HOME) => `${basePath}/${route}`,
	// Onboarding routes
	toOnboardingCreateProfile: () => '/onboarding/create-profile',
	toOnboardingSelectPlan: () => '/onboarding/select-plan',
	toOnboardingCheckout: () => '/onboarding/checkout',
	toOnboardingWelcome: () => '/onboarding/welcome',
	toOnboardingStep: step => `/onboarding/step-${step}`,
	toOnboardingRecommendedVideos: () => '/onboarding/recommended-videos',
	toChargebeePortal: () => `/AdminDashboard/chargebee-portal`
};
